import script from "./PreAllocationConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreAllocationConfirmDialog.vue?vue&type=script&setup=true&lang=ts"

import "./qualificationDialog.css?vue&type=style&index=0&id=42fac91d&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fac91d"]])

export default __exports__